import {animate, state, style, transition, trigger} from '@angular/animations';

/** Auxiliary 'appAnimationTriggers' variable.' */
export const appAnimationTriggers = {
	openCloseLeftPanel: trigger('openCloseLeftPanel', [
		state(
			'open',
			style({
				left: 0,
			})
		),
		state(
			'closed',
			style({
				left: '-22rem',
			})
		),
		transition('open => closed', [animate('0.5s')]),
		transition('closed => open', [animate('0.5s')]),
	]),
	openCloseDelimiter: trigger('openCloseDelimiter', [
		state(
			'open',
			style({
				marginLeft: '22rem',
			})
		),
		state(
			'closed',
			style({
				marginLeft: '1.5rem',
			})
		),
		transition('open => closed', [animate('0.5s')]),
		transition('closed => open', [animate('0.5s')]),
	]),
	openCloseRightPanel: trigger('openCloseRightPanel', [
		state(
			'open',
			style({
				width: 'calc(100% - 22rem - 4px)',
			})
		),
		state(
			'closed',
			style({
				width: 'calc(100% - 1.5rem - 4px)',
			})
		),
		transition('open => closed', [animate('0.5s')]),
		transition('closed => open', [animate('0.5s')]),
	]),
};
